export default {
  SignOut: 'Sign out',
  Tree: {
    Dashboard: {
      Title: 'Dashboard',
      Options: {
        YourDashboard: 'Your dashboard',
      },
    },
    Profile: {
      Title: 'Profile',
      Options: {
        Profile: 'Profile',
      },
    },
  },
};
